import { ChangeDetectionStrategy, Component, input, Signal } from '@angular/core'
import { TableModule } from 'primeng/table'
import { CertificateDocumentsApiResponse } from '@features/certificate/models/certificate-documents/certificate-documents.model'
import { CertificateBaseComponent } from '@features/certificate/components/certificate-base/certificate-base.component'

@Component({
  selector: 'albert-certificate-documents',
  imports: [
    TableModule
  ],
  templateUrl: './certificate-documents.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateDocumentsComponent extends CertificateBaseComponent {
  public readonly documents = input.required<Signal<CertificateDocumentsApiResponse[]>>()
}
